import { DefaultState, DropdownItem } from 'store/types';

export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';

export type GetRolesState = DefaultState & {
  contents?: DropdownItem[];
};

interface GetRolesRequest {
  type: typeof GET_ROLES_REQUEST;
}

interface GetRolesSuccess {
  type: typeof GET_ROLES_SUCCESS;
  contents: DropdownItem[];
}

interface GetRolesFailure {
  type: typeof GET_ROLES_FAILURE;
}

export type GetRolesActionTypes = GetRolesRequest | GetRolesSuccess | GetRolesFailure;